import React from 'react';
import { HeroSlideshow } from '@components/molecules/HeroSlideshow/HeroSlideshow';
import { PowerBranding } from '@components/molecules/PowerBranding/PowerBranding';

export default function PageContentElementHero(element, index, data) {
  if (data?.power_branding?.power_branding_image_portrait?.url)
    return <PowerBranding branding={data?.power_branding} />;
  return <HeroSlideshow slides={element?.hero_slides} />;
}
